module.exports = __webpack_public_path__ + "0b83d2022f73afcd8edfb8391a1725e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/migrate_header_complete.jpg
// module id = 1830
// module chunks = 1